import apiClient from './client';
import type { FunnelAnalytics } from '../types/funnelAnalytics';

/**
 * Client for the checkout-funnel analytics endpoint.
 *
 * Returns ordered step counts (distinct sessions per step), conversion and
 * drop-off between steps, plus bundle-tier / device-color breakdowns for the
 * checkout-started and purchased steps. The backend clamps `days` to
 * [1, 730].
 */
export async function getFunnelAnalytics(
  days: number = 30
): Promise<FunnelAnalytics> {
  const { data } = await apiClient.get<FunnelAnalytics>(
    '/admin/funnel/analytics/',
    { params: { days } }
  );
  return data;
}
